import { createSlice } from "@reduxjs/toolkit";
import { getSites } from '../reduxApi/SiteReduxApi'

const siteSlice = createSlice({
    name: 'site',
    initialState: {
        status: 'idel',
        site: [],
    },
    reducers: {
        deleteSiteAction: (state, action) => {
            action.payload.forEach((id) => {
                const index = state.site.findIndex((item) => item.sites.ROWID === id);
                if (index !== -1) {
                    state.site.splice(index, 1);
                }
            });
        },
        updateSiteAction: (state, action) => {
            console.log("action", action.payload)
            const index = state.site.findIndex((item) => item.sites.ROWID === action.payload.ROWID)
            if (index != -1) {
                state.site.splice(index, 1, { sites: action.payload })
            }
        },
        addSiteAction: (state, action) => {
            console.log("Adding site:", action.payload);
            const temp = action.payload.formData;
            temp.ROWID = action.payload.ROWID
            state.site.unshift({ sites: temp });
        }
    },
    extraReducers: (builder) => {
        builder.addCase(getSites.pending, (state, action) => {
            state.status = 'pending'
        })
            .addCase(getSites.fulfilled, (state, action) => {
                state.status = 'fulfilled'
                console.log("testing site Data", action.payload)
                state.site = action.payload.data.response
                    ;
            })
    }
})
export const { deleteSiteAction, updateSiteAction, addSiteAction } = siteSlice.actions
export default siteSlice.reducer